import { Routes, Route, Navigate } from 'react-router-dom'
import { AdminHomePage } from '../../pages/adminHome/adminHome.component'
import { AdminDashBoard } from '../../components/adminDashboard/adminDashboard.component';
import { IdeasReviewList } from '../../layout/ideasReviewList/ideasReviewList.component';
import { JuryMemberListAdminView } from '../../layout/juryMemberList/juryMemberListAdminView.component';
import { IdeaReviewForm } from '../../components/ideaReviewForm/ideaReviewForm.component';
import { JuryForm } from '../../components/juryForm/juryForm';
import { JuryMemberAboutAdmin } from '../../components/juryMemberCard/juryMemberAboutAdmin';
import { UserList } from '../../layout/usersList/usersList.component';
import { UserForm } from '../../components/userForm/userForm.component';


export const AdminRoutes = () => {
    return (
        <Routes>
            <Route exact path="/" element={<AdminHomePage />}>
                <Route exact path='/' element={<AdminDashBoard />} />
                <Route exact path='/ideas' element={<IdeasReviewList />} />
                <Route exact path='/ideas/idea-details/:ideaId' element={<IdeaReviewForm />} />
                <Route exact path='/jury-list' element={<JuryMemberListAdminView />} />
                {/* <Route exact path='/jury-list/add-jury' element={<JuryForm isDelete={false} formHeading={"ADD JURY MEMBER"} isUpdate={false}/>} /> */}
                <Route exact path='/jury-list/about/:id' element={<JuryMemberAboutAdmin/>} />
                {/* <Route exact path='/jury-list/about/:id/edit' element={<JuryForm isDelete={false} formHeading={"EDIT JURY MEMBER"} isUpdate={true}/>} /> */}
                <Route exact path='/users' element={<UserList />} />
                <Route exact path='/users/add-user' element={<UserForm isDelete={false} formHeading={"ADD USER MEMBER"} isUpdate={false}/>} />
                <Route exact path='/users/:id/edit' element={<UserForm isDelete={false} formHeading={"EDIT USER MEMBER"} isUpdate={true}/>} />
            </Route>
            <Route path="*" element={<Navigate to={"/"} replace={false} />} />
        </Routes>
    )
}